import { useAuth } from "../../context/AuthContext";

/**
 * Renderiza `fallback` si el usuario NO tiene coordenadas (location_cordena),
 * si las tiene renderiza children normalmente.
 *
 * Uso:
 *   <RequireCoordinates fallback={<PedirDireccion />}>
 *     <AppRoutes />
 *   </RequireCoordinates>
 */
export const RequireCoordinates = ({ children, fallback = null }) => {
    const { user } = useAuth();
    const hasCoordinates = Boolean(user?.location_cordena);

    if (!hasCoordinates) return fallback;

    return children;
};
